// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Sb3d","box":"WorkspacesBox_box__1i45F","node":"WorkspacesBox_node__1kEDc"};